module.exports = __webpack_public_path__ + "img/gradient-3.8d322b2f.png";